export const comboVisitaValorIds = {
    VISITA_PROGRAMADA_ID: 3
}